import React, { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { ShieldCheck } from "lucide-react";

export default function Login() {
  const { user, loading } = useAuth();
  const navigate = useNavigate();

  useEffect(() => {
    if (!loading && user) navigate("/admin");
  }, [user, loading, navigate]);

  const login = () => {
    // REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
    const redirectUrl = window.location.origin + "/admin";
    window.location.href = `https://auth.emergentagent.com/?redirect=${encodeURIComponent(redirectUrl)}`;
  };

  return (
    <div className="min-h-screen bg-luxe flex items-center justify-center px-5">
      <div className="glass rounded-xl p-10 max-w-md w-full text-center">
        <ShieldCheck className="text-gold mx-auto" size={40} />
        <h1 className="text-3xl mt-5 gold-text font-serif">Admin Portal</h1>
        <p className="text-white/60 text-sm mt-3">Spunky Scissors Salon &amp; Academy management dashboard.</p>
        <button onClick={login} className="btn-gold w-full mt-8" data-testid="google-login-btn">Sign in with Google</button>
        <a href="/" className="block text-white/50 text-xs mt-5 hover:text-gold">← Back to website</a>
      </div>
    </div>
  );
}
